module.exports = __webpack_public_path__ + "static/img/settings-bdbdbd.988ad91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/settings-bdbdbd.svg
// module id = PB08
// module chunks = 103